export default "__VITE_ASSET__BFRzulv6__"